import { render } from "./TopOffersHeader.vue?vue&type=template&id=5995500c"
import script from "./TopOffersHeader.vue?vue&type=script&lang=js"
export * from "./TopOffersHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__